module.exports = __webpack_public_path__ + "img/bons.28fd3712.svg";